import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {WebsiteModuleStore} from "./website-module-store";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {WebsiteModuleConfig} from "./website-module.config";
import {WebsiteModuleHandlers} from "./handlers/website-module-handlers";

export class WebsiteModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, WebsiteModuleConfig, WebsiteModuleStore, WebsiteModuleHandlers];
}
